var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-left"},[(_vm.options)?_c('inline-multi-select',{staticClass:"max-size",attrs:{"classes":_vm.classes,"disabled":false,"value":_vm.value,"placeholder":_vm.placeholder,"searchEnabled":_vm.searchEnabled,"options":_vm.options},on:{"change":_vm.onDataUpdated,"search":_vm.onSearch}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }